var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6498 3.95682C15.5719 3.75924 18.8132 6.90539 18.8132 10.8136C18.8132 12.5595 18.1667 14.1491 17.1068 15.3609L16.9448 15.5398L12.7985 19.7183C12.3849 20.1353 11.7302 20.1612 11.2864 19.7964L11.2006 19.7182L7.0674 15.552C5.8449 14.2561 5.1166 12.4854 5.19226 10.5375C5.32911 7.01081 8.15207 4.13296 11.6498 3.95682ZM11.9995 5.71604C9.20998 5.71604 6.9413 8.00236 6.9413 10.8136C6.9413 12.0439 7.37645 13.2185 8.17086 14.1475L8.324 14.3188L11.9995 18.0228L15.686 14.3088C16.5719 13.3563 17.0588 12.1164 17.0588 10.8136C17.0588 8.00236 14.789 5.71604 11.9995 5.71604ZM12.0001 8.21356C13.391 8.21356 14.5186 9.34996 14.5186 10.7518C14.5186 12.1536 13.391 13.2898 12.0001 13.2898C10.6092 13.2898 9.48152 12.1536 9.48152 10.7518C9.48152 9.34996 10.6092 8.21356 12.0001 8.21356Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIc);
export default __webpack_public_path__ + "static/media/location_ic.8a6c4162.svg";
export { ForwardRef as ReactComponent };